import { lazy } from 'react';
import { createRoot } from 'react-dom/client';

import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import { User, UserManager } from 'oidc-client-ts';

import { authInit } from '@da-g3-acl/api-infra/auth';
import { getConfig } from '@da-g3-acl/api-infra/env-config';

import { type AnalyticsConfig } from './config';
import './index.scss';

const container = document.getElementById('root') as HTMLElement;
if (!container) throw Error('No element with id "root" found');

ModuleRegistry.registerModules([AllCommunityModule]);

async function init(): Promise<{
	config: AnalyticsConfig;
	userManager: UserManager;
	user: User;
}> {
	const config = await getConfig(import.meta.env.DEV, (window) => window.ANALYTICS_APP_CONFIG);
	const { user, userManager } = await authInit(config.analyticsApp.auth);

	return { config: config.analyticsApp, userManager, user };
}

async function run(): Promise<void> {
	const { config, userManager, user } = await init();

	const LazyAppProviders = lazy(() => import('./AppProviders'));
	const LazyAppRoutes = lazy(() => import('./AppRoutes'));
	const root = createRoot(container);
	root.render(
		<LazyAppProviders config={config} oidcUserManager={userManager} user={user}>
			<LazyAppRoutes />
		</LazyAppProviders>,
	);
}

run();
